import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=60dd48d6"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=60dd48d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports